export const ELEMENT_PROPERTY_NAME = {
    Label: "label",
    Required: "required",
    Default: "default",
    Literal: "literal",
    LastPageTitle: "lastpagetitle",
    PageTitle: "pagetitle",
    AllowSameAs: "allowsameas",
    ShadingModel: "shadingmodel",
    InverterListFiltering: "inverterlistfiltering",
    Visibility: "visibility",
    ListView: "listview",
    Min: "min",
    Max: "max",
    Readonly: "readonly",
    HelpText: "helptext",
    HelpLink: "helplink",
    Precision: "precision",
    Prefix: "prefix",
    Units: "units",
    ShowCounty: "showcounty",
    OutputFormat: "outputformat",
    ButtonLabel: "buttonlabel",
    AdapterConfigId: "adapterconfigid",
    FormulaId: "formulaid",
    ShowFormulaDetails: "showformuladetails",
    Href: "href",
    DisplayText: "displaytext",
    AdminRoleFilter: "adminrolefilter",
    EarliestAbsoluteDate: "earliestabsolutedate",
    EarliestDateWindowSize: "earliestdatewindowsize",
    LatestAbsoluteDate: "latestabsolutedate",
    LatestDateWindowSize: "latestdatewindowsize",
    EnforcePhoneFormat: "enforcephoneformat",
    ShowAllowedExtensions: "showallowedextensions",
    AddRowOnly: "addrowonly",
    RequireRows: "requirerows",
    AllowTableImport: "allowtableimport",
    AllowProjectTableAddExistingProject: "allowprojecttableaddexistingproject",
    TableColumnOrder: "tablecolumnorder",
    ContentItemId: "contentitemid",
    ContentPath: "contentpath",
    ContentIsPublic: "contentispublic",
    Position: "position",
    SizeOnPage: "sizeonpage",
    AltText: "alttext",
    Caption: "caption",
    FormToOpen: "formtoopen",
    CanEditRow: "caneditrow",
    CanViewRow: "canviewrow",
    CanAddRow: "canaddrow",
    CanDeleteRow: "candeleterow",
    VisibleColumns: "visiblecolumns",
    EditableColumns: "editablecolumns",
    ShowRowStatus: "showrowstatus",
    LeftLabel: "leftlabel",
    RightLabel: "rightlabel",
    StartValue: "startvalue",
    EndValue: "endvalue",
    LocationType: "locationtype",
    LocationSubElementId: "locationsubelementid",
    IsDynamicElement: "isdynamicelement",
    EnableAutocomplete: "enableautocomplete",
    UseAddressAutocompleteFilter: "useaddressautocompletefilter",
    ShowLocationMap: "showlocationmap"
};

export const RELATIONAL_OPERATOR_CONSTANT = {
    // Conditional Visibility RelationalOperatorConstant
    IsEqualTo: 1,
    IsNotEqualTo: 2,
    IsGreaterThan: 3,
    IsLessThan: 4,
    IsEmpty: 5,
    IsNotEmpty: 6,
    IsGreaterThanOrEqual: 7,
    IsLessThanOrEqual: 8,
    IsBetween: 9,
    IsBetweenOrEqual: 10
};
